import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box, Tab, Tabs, Grid, IconButton} from '@material-ui/core'
import {Button, FormControl, Checkbox, TextField, InputLabel, MenuItem, Select } from '@material-ui/core';

import { TabPanel } from '../../../components/TabPanel';

import {MoreVert} from '@material-ui/icons';
import {HighlightOff} from '@material-ui/icons';
//import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import { isInteger, isNumber } from '../../../api/validators';
import { getObjectByID } from '../../../api/helpers';
import { SelectExternalNetworkGroupDialog } from './SelectExternalNetworkGroupDialog';

import * as dev from '../../../api/dev';

export default class EditGroupDialog_ extends React.Component{

    constructor(props){
        super(props)

        let group = JSON.parse(JSON.stringify(this.props.group))

        if(!group.ID) group = {
            Name: '',
            Priority: 0,
            LocationPeriod: 0,
            Emergency: 0,
            AllCall: 0,
            Broadcast: 0,
            SipID: '',
            Echo: 0
        }


        this.state = {
            group: group,
            errors:{
                Name: false,
                LocationPeriod: false,
                SipID: false
            },
            changed: false,
            tab: 0,
            selectExternalNetworkGroupDialog:{
                open: false,
                externalNetworks: []
            }
        }


        this.handleTabChange = this.handleTabChange.bind(this)
        this.handleAction = this.handleAction.bind(this)
        this.handleInput = this.handleInput.bind(this)

        this.handleSave = this.handleSave.bind(this)
        this.handleClose = this.handleClose.bind(this)

    }

    handleTabChange(event, newValue){
        this.setState({tab: newValue})
    }

    handleSave(){
        if(this.validate()){
            let group = {...this.props.group, ...this.state.group}
            this.props.onAction({type: 'GROUP_EDITOR_SAVE', group: group})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'GROUP_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'GROUP_EDITOR_CLOSE'})
        }
    }

    handleInput(event){
        if(!this.state.changed) this.setState({changed: true})

        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const group = {...this.state.group, [event.target.name]: val}
        this.setState({group: group})
    }

    handleAction(action){
        switch(action.type){
            case 'SELECT_DMR_GROUP_DIALOG_OPEN':{
                console.log('SELECT_DMR_GROUP_DIALOG_OPEN')
                console.log(this.props)
                this.setState({selectExternalNetworkGroupDialog:{
                    open: true,
                    externalNetworks: this.props.externalNetworks,
                    DMRNetworkID: this.state.group.DMRNetworkID,
                    DMRGroupID: this.state.group.DMRGroupID,
                    DMRSlot: this.state.group.DMRSlot
                }})

                break
            }

            case 'SELECT_DMR_GROUP_DIALOG_CLOSE':{

                this.setState({selectExternalNetworkGroupDialog:{
                    open: false,
                    externalNetworks: [] // this.props.externalNetworks
                }})
                break
            }

            case 'SELECT_DMR_GROUP_DIALOG_SELECT':{

                let group = {...this.state.group}

                group.DMRNetworkID = action.DMRNetworkID
                group.DMRGroupID = action.DMRGroupID
                group.DMRSlot = action.DMRSlot

                this.setState({
                    group: group,
                    selectExternalNetworkGroupDialog:{
                        open: false,
                        externalNetworks: [] // this.props.externalNetworks
                    }
                })

                break
            }

            case 'CLEAR_DMR_GROUP':{
                let group = {...this.state.group}
                group.DMRNetworkID = 'AAAAAAAAAAAAAAAAAAAAAA=='
                group.DMRGroupID = 0
                group.DMRSlot = 0
                this.setState({group: group})
                break
            }


            default:
                dev.alert('EditGroupDialog handleAction not defined for '+action.type)
            
        }

    }

    validate(){
        let errors = this.state.errors;
        let error = false
     
        if(!this.state.group.Name){
            errors.Name = this.props.t('NameIsEmpty')
            error = true
        }else{
            errors.Name = false
        }
        this.setState({errors: errors})


        if(this.state.group.LocationPeriod && !isNumber(this.state.group.LocationPeriod)){
            errors.LocationPeriod = this.props.t('IsNotNumber')
            error = true
        }else if(this.state.group.LocationPeriod && !isInteger(this.state.group.LocationPeriod)){
            errors.LocationPeriod = this.props.t('IsNotInteger')
            error = true
        }else{
            errors.LocationPeriod = false
        }

        return !error;
    }


    render(){
        const {t} = this.props

        const title = this.props.action==='add'?t('NewGroup'):t('EditGroup')

        const margin = {margin:'16px 0 8px 0'}

        console.log('render EditGroupDialog')
        console.log(this.state)


        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            tab:{
                minWidth:80
            },
            tabPanel:{
                minHeight: 300
            }
        };


        let dmrGroup = ''

        console.log('this.props.externalNetworks')
        console.log(this.props.externalNetworks)

        const externalNetwork = getObjectByID(this.state.group.DMRNetworkID, this.props.externalNetworks)
        console.log('externalNetwork '+this.state.group.DMRNetworkID)
        console.log(externalNetwork)

        if(externalNetwork){
            const externalGroup = getObjectByID(this.state.group.DMRGroupID, externalNetwork.Groups, 'GroupID')
            console.log('externalGroup '+this.state.group.DMRGroupID)
            console.log(externalGroup)

            if(externalGroup){
                dmrGroup = externalNetwork.Name+' / '+externalGroup.Name+' ('+externalGroup.GroupID+', '+externalGroup.Slot+')'
            }
        }


        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:550}}>

            <Tabs  value={this.state.tab} 
                variant="scrollable"
                scrollButtons="auto"
                onChange={this.handleTabChange} aria-label="simple tabs example"
                indicatorColor="primary">
                <Tab wrapped style={styles.tab} label={t("General")} id="tab-0" aria-controls="tabpanel-0" />
                <Tab wrapped style={styles.tab} label={t("DMR")} id="tab-1" aria-controls="tabpanel-1" />
                <Tab wrapped style={styles.tab} label={t("SIP")} id="tab-2" aria-controls="tabpanel-2" />
                <Tab wrapped style={styles.tab} label={t("Other")} id="tab-3" aria-controls="tabpanel-3" />
            </Tabs>

            <TabPanel value={this.state.tab} index={0} style={styles.tabPanel}>

                <Box textAlign="">
                    <TextField name="Name"  margin="normal"
                        style={{width: '100%'}}
                        label={this.state.errors.Name?this.state.errors.Name:t('Name')}
                        autoComplete="off"
                        error={this.state.errors.Name!==false}
                        value={this.state.group.Name}
                        onChange={this.handleInput}
                    />

                </Box>
                
                <Box textAlign="">
                <FormControl style={{...margin, width: '100%'}}>
                    <InputLabel htmlFor="Priority">{t('Priority')}</InputLabel>
                    <Select
                        value={this.state.group.Priority}
                        onChange={this.handleInput}
                        inputProps={{
                            name: 'Priority',
                            id: 'Priority',
                        }}
                        >
                        <MenuItem key="5" value={5}>+5</MenuItem>
                        <MenuItem key="4" value={4}>+4</MenuItem>
                        <MenuItem key="3" value={3}>+3</MenuItem>
                        <MenuItem key="2" value={2}>+2</MenuItem>
                        <MenuItem key="1" value={1}>+1</MenuItem>
                        <MenuItem key="0" value={0}>{t('Default')}</MenuItem>
                        <MenuItem key="-1" value={-1}>-1</MenuItem>
                    </Select>
                </FormControl>
                </Box>

                <Box textAlign="center">
                    <TextField name="LocationPeriod"  margin="normal"
                        style={{width: '100%'}}
                        label={this.state.errors.LocationPeriod?this.state.errors.LocationPeriod:t('LocationPeriod')}
                        autoComplete="new-password"
                        error={this.state.errors.LocationPeriod!==false}
                        value={this.state.group.LocationPeriod}
                        onChange={this.handleInput}
                    />
                </Box>

                <Box textAlign="" style={{...margin, width: '100%'}}>
                    <FormControl>
                        <label>
                            <Checkbox color="primary" 
                                checked={Boolean(this.state.group.Emergency)}
                                onChange={this.handleInput}
                                name="Emergency"
                                />
                                {t('Emergency')}
                        </label>
                    </FormControl>
                </Box>

                <Box textAlign="" style={{...margin, width: '100%'}}>
                    <FormControl>
                        <label>
                            <Checkbox color="primary" 
                                checked={Boolean(this.state.group.AllCall)}
                                onChange={this.handleInput}
                                name="AllCall"
                                />
                                {t('AllCall')}
                        </label>
                    </FormControl>
                </Box>

                <Box textAlign="" style={{...margin, width: '100%'}}>
                    <FormControl>
                        <label>
                            <Checkbox color="primary" 
                                checked={Boolean(this.state.group.Broadcast)}
                                onChange={this.handleInput}
                                name="Broadcast"
                                />
                                {t('Broadcast')}
                        </label>
                    </FormControl>
                </Box>

            </TabPanel>

            <TabPanel value={this.state.tab} index={1} style={styles.tabPanel}>

                <Box textAlign="center">
                    <Grid container>
                        <Grid item xs={10} align="left">
                            <TextField name="DmrGroup"  margin="normal"
                                onChange={()=>{this.handleAction({type: 'SELECT_DMR_GROUP_DIALOG_OPEN'})}}
                                style={{width: '100%'}}
                                label={this.state.errors.DmrGroup?this.state.errors.DmrGroup:t('DmrGroup')}
                                autoComplete="new-password"
                                error={false}
                                value={dmrGroup}
                            />
                        </Grid>
                        <Grid item xs={2} style={{verticalAlign:'bottom', paddingTop:33}}>
                            <IconButton
                                size="small" color="inherit" aria-label="more edit" component="span"
                                onClick={()=>{this.handleAction({type: 'SELECT_DMR_GROUP_DIALOG_OPEN'})}}>
                                <MoreVert />
                            </IconButton>
                            <IconButton disabled={!dmrGroup} 
                                size="small" color="inherit" aria-label="clear" component="span"
                                onClick={()=>{this.handleAction({type: 'CLEAR_DMR_GROUP'})}}>
                                <HighlightOff/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Box>

                {this.state.selectExternalNetworkGroupDialog.open?
                <SelectExternalNetworkGroupDialog
                    fullWidth={500}
                    {...this.state.selectExternalNetworkGroupDialog}
                    onAction={this.handleAction}
                 />
                 :''
                }

            </TabPanel>

            <TabPanel value={this.state.tab} index={2} style={styles.tabPanel}>

                <Box textAlign="center">
                    <TextField name="SipID"  margin="normal"
                        style={{width: '100%'}}
                        label={this.state.errors.SipID?this.state.errors.SipID:t('SipID')}
                        autoComplete="new-password"
                        error={this.state.errors.SipID!==false}
                        value={this.state.group.SipID}
                        onChange={this.handleInput}
                    />
                </Box>

            </TabPanel>


            <TabPanel value={this.state.tab} index={3} style={styles.tabPanel}>
                <Box textAlign="" style={{...margin, width: '100%'}}>
                    <FormControl>
                        <label>
                            <Checkbox color="primary" 
                                checked={Boolean(this.state.group.Echo)}
                                onChange={this.handleInput}
                                name="Echo"
                                />
                                {t('EchoGroup')}
                        </label>
                    </FormControl>
                </Box>
            </TabPanel>
        
        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditGroupDialog = withTranslation()(EditGroupDialog_);